import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';

import './style.scss';
import { appVersion, config } from '../../config';
import Header from './Header';
import DigitalPaymentFooter from '../../pages/digitalPayment/components/DigitalPaymentFooter';
import { previousPageState } from '../../state';
import { useRecoilState } from 'recoil';

const whitelist = [
	'/contact-us',
	'/Mypolicy/Mypolicy-detail',
	'/payment-directdebit/bank-account',
	'/d/contact-us',
	'/d/Mypolicy/Mypolicy-detail',
	'/d/payment-directdebit/bank-account',
	'/persona-health',
	'/big-reward-campaign',
];

const Layout = props => {
	const { currentPage } = props;
	const styles = {
		backgroundColor: whitelist.indexOf(currentPage) !== -1 ? '#fff' : '',
	};
	const [previousPage] = useRecoilState(previousPageState);

	const CheckIgnoreHeaderPages = () => {
		let modifyHeader =
			currentPage === '/login' ||
			currentPage === '/index-level-table' ||
			currentPage === '/search-partner/agent' ||
			currentPage === '/search-partner/broker';
		return modifyHeader ? <></> : <Header {...props} />;
	};

	const CheckIgnoreFooterPages = () => {
		let modifyFooter =
			currentPage === '/index-level-table' ||
			currentPage === '/search-partner/agent' ||
			currentPage === '/search-partner/broker' ||
			currentPage === '/tx' || shouldShowFooter
		return modifyFooter ? (
			<></>
		) : (
			<>
				<footer style={styles}>
					<span>
						v{appVersion} {config.mode !== 'prd' && config.mode}
					</span>
				</footer>
			</>
		);
	};

	const shouldShowFooter =
		currentPage === '/digital-payment' ||
		/^\/digital-payment\/form-summary\/[^/]+$/.test(currentPage) ||
		currentPage === '/digital-payment/complete';

	const FooterDigitalPaymentOnlyPages = () => {
		return shouldShowFooter && (
			<>
				<DigitalPaymentFooter />
			</>
		)
	};

	return (
		<Fragment>
			{CheckIgnoreHeaderPages()}
			{currentPage !== '/index-level-table' ? (
				<main id="main" className={previousPage ? 'with-navheader' : ''} style={styles}>
					<Container>
						<Row>
							<Col
								// className="bg-light border"
								md={12}
							// lg={{ size: 8, offset: 2 }}
							>
								{props.children}
							</Col>
						</Row>
					</Container>
					{FooterDigitalPaymentOnlyPages()}
				</main>
			) : (
				<div>
					<Fragment>{props.children}</Fragment>
				</div>
			)}
			{CheckIgnoreFooterPages()}
		</Fragment>
	);
};

export default Layout;
